import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Input, Button, Image, Segment, Dimmer, Popup, Loader, Icon, Label, Dropdown } from 'semantic-ui-react';
import _ from 'lodash';
import numeral from 'numeral';
import axios from 'axios';
import { withRouter } from 'react-router';
import { isEmail } from 'validator';
import { compose } from 'recompose';
import hasRestClient from '../../hocs/has-rest-client';

const wrapperStyles = {
  marginBottom: 30,
};

const tableStyles = {
  height: '400px',
  overflow: 'scroll',
  borderBottom: 'solid 1px #d8d8d8',
  marginTop: 10,
};

const socialHandle = {
  foregroundColor: 'grey',
  fontSize: 'smaller',
};

const cf = num => numeral(num).format('0a');

const ChannelAddedComponent = ({ channel }) => (
  <Segment fluid textAlign="center" style={{ height: 300, padding: 30 }}>
    <Icon name="check circle outline" color="green" size="huge" />
    <br />
    <br />
    <h2>Channel Added!</h2>
    <br />
    <p><Label basic color="pink" size="huge"><Icon name="instagram" />{channel.metadata.instagram}</Label></p>
    <br />
    <p>An ACR only works with one Instagram channel.</p>
    <p>Use the list in <strong>My Team</strong> to add team members.</p>
  </Segment>
);

class InfluencerTable extends Component {
  static propTypes = {
    onInvite: PropTypes.func.isRequired,
    campaign: PropTypes.object,
    visible: PropTypes.bool.isRequired,
    processing: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    campaign: null,
  };

  constructor() {
    super();
    this.state = {
      invited: [],
      added: [],
      filter: null,
      loading: false,
      error: false,
      invitingInfluencer: null,
      prefixSearch: true,
    };

    this.searchClient = axios.create({
      baseURL: `${process.env.REACT_APP_INFLUENCER_FILTER_API}/filter`,
      timeout: 30000,
    });
  }

  componentDidMount = () => {
    this.fetch();
  }

  localAdd = (e, v) => {
    this.setState({
      invitingInfluencer: v.value.id,
    });
    const added = this.state.added;
    const addition = this.getCampaignInvitationFromInput(v.value);
    addition.status = 'DEFERRED';
    added.push(addition);
    this.setState({
      added,
    });
    this.props.onInvite(addition);
  }

 fixInfluencerRedirect = async id => {
   const { organisationId, restClient } = this.props;
   const linkUrl = `influencerLink?filter[influencer]=${id}&filter[organisation]=${organisationId}`;
   const link = await restClient.get(linkUrl);
   if (link) {
     const linkId = _.get(link, 'data.data[0].id');
     window.open(`/influencer/${linkId}/profile`);
   } else {
     console.error('Could not find influencer link.');
   }
 }

  getInvitationButton = (members, pending, influencer) => {
    const invited = this.state.invited;
    const invitedEmails = _.map(invited, 'email');
    const membersAndPendingAndInvited = _.concat(members, pending, invitedEmails);

    if (!influencer.email) {
      return (
        <p className="small light">no email</p>
      );
    }

    if (_.includes(membersAndPendingAndInvited, influencer.email)) {
      return (
        <Button fluid basic disabled color="green">invited</Button>
      );
    }

    return (
      <Button
        size="small"
        color="green"
        onClick={this.localInvite}
        value={influencer}
        icon="mail outline"
        iconPosition="left"
        content="invite"
      />
    );
  }

  getAddButton = (members, pending, influencer) => {
    const invited = this.state.invited;

    const { invitingInfluencer } = this.state;
    const invitedEmails = _.map(invited, 'email');
    const membersAndPendingAndInvited = _.concat(members, pending, invitedEmails);

    if (_.includes(membersAndPendingAndInvited, influencer.email)) {
      return (
        <Button fluid disabled color="pink">added</Button>
      );
    }

    const { organisation, processing } = this.props;
    const emailRequired = _.get(organisation, 'influencerEmailRequired', false);
    const isEmailBad = (_.isEmpty(influencer.email)
      || !isEmail(_.get(influencer, 'email'))
      || influencer.email.match(/info\+\w{8}@/));

    if (emailRequired && isEmailBad) {
      return (
        <Popup
          content="Missing or invalid email. You will be redirected to influencer's page."
          trigger={
            <Button
              size="small"
              color="orange"
              onClick={() => this.fixInfluencerRedirect(influencer.id)}
              value={influencer}
              fluid
              icon="settings outline"
              iconPosition="left"
              content="fix"
            />
          }
        />
      );
    }

    return (
      <Button
        size="small"
        color="pink"
        fluid
        disabled={influencer.id === invitingInfluencer || processing}
        onClick={this.localAdd}
        value={influencer}
        icon="plus square outline"
        iconPosition="left"
        content="add"
      />
    );
  }

  getCampaignInvitationFromInput = input => ({
    email: input.email,
    name: input.name,
    role: 'INFLUENCER',
    id: input.id,
    primarySocialHandle: input.primarySocialHandle,
    instagram: input.instagram,
  });

  handleSearchChange = (e, { value }) => {
    this.setState({
      filter: value,
    }, this.fetchIf);
  };

  setPrefix = prefixSearch => {
    this.setState({ prefixSearch }, this.fetchIf);
  };

  fetchIf = _.debounce(() => {
    const { filter } = this.state;

    if (filter.length >= 3) {
      this.fetch();
    }
  }, 1000);

  fetch = () => {
    this.setState({
      loading: true,
    });

    const { filter } = this.state;
    const { organisationId } = this.props;

    const term = filter && filter.length >= 3 ? filter : '';

    const request = {
      data: {
        organisationId,
        perPage: 100,
        currentPage: 1,
        search: term ? { searchTerm: term, prefix: this.state.prefixSearch } : {},
      },
    };

    const searchURI = encodeURIComponent(JSON.stringify(request));

    // Text search -> dedicated /search/ endpoint; empty/browse -> /filter/.
    const url = term
      ? `${process.env.REACT_APP_INFLUENCER_FILTER_API}/search/${searchURI}`
      : `${process.env.REACT_APP_INFLUENCER_FILTER_API}/filter/${searchURI}`;

    const isVoxogram = window.location.hostname === 'app.voxogram.com';

    this.searchClient.get(url)
      .then(r => {
        const influencerLinks = r.data.body.data.data;
        const resultsWithEmails = _.map(influencerLinks, link => {
          const influencer = link.lookupInfluencer;
          const shortId = _.split(influencer.id, '-')[0];
          const fakeEmail = `info+${shortId}@${isVoxogram ? 'voxogram.com' : 'dyzio.co'}`;
          const derivedEmail = influencer.email || fakeEmail;
          influencer.email = derivedEmail;
          return link;
        });
        this.setState({
          influencers: resultsWithEmails,
          loading: false,
          error: false,
        });
      }).catch(e => {
        console.log('Error', e);
        this.setState({
          loading: false,
          error: true,
        });
      });
  }

  localInvite = (e, v) => {
    const invited = this.state.invited;
    const invitation = this.getCampaignInvitationFromInput(v.value);
    invited.push(invitation);
    this.setState({
      invited,
    });
    this.props.onInvite(invitation);
  }

  getLoadingRow = () => {
    const loaderStyles = {
      height: '100%',
    };
    return (
      <Table.Row>
        <Table.Cell colSpan={9} height="400">
          <Segment style={loaderStyles}>
            <Dimmer active inverted>
              <Loader indeterminate>Loading Influencers...</Loader>
            </Dimmer>
          </Segment>
        </Table.Cell>
      </Table.Row>
    );
  }

  getErrorRow = () => {
    const errorStyles = {
      height: '100%',
      'padding-top': '100px',
      'text-align': 'center',
    };
    return (
      <Table.Row>
        <Table.Cell colSpan={9} height="400">
          <Segment style={errorStyles}>
              Error searching database, please try again.
          </Segment>
        </Table.Cell>
      </Table.Row>
    );
  }

  render() {
    const { campaign, visible } = this.props;
    const { influencers, loading, error } = this.state;

    if (!campaign) return null;
    const memberEmails = campaign ? _.map(campaign.members, 'email') : [];
    const pendingEmails = campaign ? _.map(campaign.pendingInvitations, 'email') : [];

    const displayStyle = visible ? {} : { display: 'none' };

    const systemEmailRegEx = /^info\+(.{8})@(voxogram.com|dyzio.co)$/i;

    const combinedArrays = _.concat(campaign.members, campaign.pendingInvitations);
    const invitedInfluencers = _.filter(combinedArrays, { role: 'INFLUENCER' });

    const { campaignType } = campaign;
    const isAcrLoaded = campaignType === 'ACR' && !_.isEmpty(invitedInfluencers);

    const channel = _.head(invitedInfluencers);

    return (
      <div style={displayStyle}>
        <div style={wrapperStyles}>

          {
            isAcrLoaded
              ? <ChannelAddedComponent channel={channel} />
              :
              <div>
                <Input
                  fluid
                  icon="search"
                  placeholder="Search My Influencers"
                  onChange={this.handleSearchChange}
                  labelPosition="left"
                  label={
                    <Dropdown
                      style={{ display: 'flex', alignItems: 'center' }}
                      value={this.state.prefixSearch ? 'prefix' : 'substring'}
                      options={[
                        { key: 'prefix', text: 'Starts with', value: 'prefix' },
                        { key: 'substring', text: 'Contains', value: 'substring' },
                      ]}
                      onChange={(e, { value }) => this.setPrefix(value === 'prefix')}
                    />
                  }
                />
                <div style={tableStyles}>
                  { visible &&
                  <Table unstackable>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell colSpan={2}>Influencer</Table.HeaderCell>
                        <Table.HeaderCell textAlign="center">
                          <img src="/icons/facebook.svg" alt="Facebook" />
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="center">
                          <img src="/icons/instagram.svg" alt="Instagram" />
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="center">
                          <img src="/icons/twitter.svg" alt="Twitter" />
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="center">
                          <img src="/icons/youtube.svg" alt="YouTube" />
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="center">
                          <img src="/icons/tiktok.svg" alt="TikTok" width="24" height="24" />
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="center">
                        Email
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="center" collapsing>Action</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      { loading && this.getLoadingRow()}
                      { !loading && error && this.getErrorRow()}
                      { !loading && !error && influencers &&
                      _.map(influencers, influencerLink => {
                        const influencer = influencerLink.lookupInfluencer;
                        return (
                          <Table.Row key={influencer.id}>
                            <Table.Cell collapsing>
                              <Image src={influencer.thumbnail} avatar size="mini" />
                            </Table.Cell>
                            <Table.Cell>
                              {influencer.name}
                              &nbsp;<span style={socialHandle}>{influencer.primarySocialHandle}</span>
                            </Table.Cell>
                            <Table.Cell textAlign="center">
                              {cf(influencer.facebookCount)}
                            </Table.Cell>
                            <Table.Cell textAlign="center">
                              {cf(influencer.instagramCount)}
                            </Table.Cell>
                            <Table.Cell textAlign="center">
                              {cf(influencer.twitterCount)}
                            </Table.Cell>
                            <Table.Cell textAlign="center">
                              {cf(influencer.youtubeCount)}
                            </Table.Cell>
                            <Table.Cell textAlign="center">
                              {cf(influencer.tiktokCount)}
                            </Table.Cell>
                            <Table.Cell textAlign="center">
                              {
                                influencer.email.match(systemEmailRegEx)
                                  ? <Label basic color="red"><Icon name="ban" />no email</Label>
                                  : influencer.email
                              }
                            </Table.Cell>
                            <Table.Cell collapsing textAlign="center">
                              { this.getAddButton(memberEmails, pendingEmails, influencer) }
                            </Table.Cell>
                          </Table.Row>
                        );
                      })
                      }
                    </Table.Body>
                  </Table>
                  }
                </div>
              </div>

          }
        </div>
      </div>
    );
  }
}

export default compose(
  hasRestClient,
  withRouter,
)(InfluencerTable);



/** WEBPACK FOOTER **
 ** ./src/components/influencer-table2/index.js
 **/